import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import "./assets/css/style.scss"
import { Provider } from "react-redux"
import store from "./store/store"
import './translation/i18next';

ReactDOM.render(
    <Provider store={store}>
        <React.StrictMode>
            <App />
        </React.StrictMode>
    </Provider>,
    document.getElementById("root")
)
